import { InjectionToken } from '@angular/core';

/** Whether the application offers Share on content at all; where it does not, cards leave Share out instead of disabling it. */
export const SHARE_OFFERED = new InjectionToken<boolean>('SHARE_OFFERED', { factory: () => true });
